import { makeAutoObservable } from 'mobx';
import apiHandler from '../handlers/ApiHandler';

class UserPreferencesStore {
  username = '';
  displayName = '';
  email = '';
  roles = [];
  fullName = '';
  address = {};
  phoneNumber = '';
  profileImage = '';
  isActive = true;

  selectedLanguage = 'English';
  selectedTimeZone = 'UTC';
  selectedDateFormat = 'MM/DD/YYYY';

  loading = false;

  constructor() {
    makeAutoObservable(this);
    this.loadUserDetails();
  }

  async loadUserDetails() {
    const userId = localStorage.getItem('userId');
    if (userId) {
      this.resetUserDetails();
      try {
        const response = await apiHandler.get(`/users/${userId}`);
        const user = response;
        this.setUserDetails(user);
      } catch (error) {
        console.error('Error loading user details:', error);
      }
    }
  }

  setUserDetails(user) {
    this.username = user.username;
    this.displayName = user.displayName;
    this.email = user.email;
    this.roles = user.roles;
    this.fullName = user.fullName;
    this.address = user.address;
    this.phoneNumber = user.phoneNumber;
    this.profileImage = user.profileImage;
    this.isActive = user.isActive;

    this.selectedLanguage = user.settings?.language || 'N/A';
    this.selectedTimeZone = user.settings?.timeZone || 'N/A';
    this.selectedDateFormat = user.settings?.dateFormat || 'N/A';
  }

  resetUserDetails() {
    this.username = '';
    this.displayName = '';
    this.email = '';
    this.roles = [];
    this.fullName = '';
    this.address = {};
    this.phoneNumber = '';
    this.profileImage = '';
    this.isActive = true;

    this.selectedLanguage = 'English';
    this.selectedTimeZone = 'UTC';
    this.selectedDateFormat = 'MM/DD/YYYY';
  }

  async updateUserDetails(updatedDetails) {
    const userId = localStorage.getItem('userId');
    if (userId) {
      try {
        await apiHandler.put(`/users/${userId}`, updatedDetails);
        this.setUserDetails(updatedDetails);
      } catch (error) {
        console.error('Error updating user details:', error);
      }
    }
  }

  userDetailsLoaded() {
    return this.username !== '' || this.loading;
  }
}

const userPreferencesStore = new UserPreferencesStore();

export default userPreferencesStore;
